import React, { useState } from "react";
import { createRole } from "@api/rolesController";
import {
  Button,
  Flow,
  FlowActions,
  FlowHeader,
  FlowTitle,
  FlowBody,
} from "@components";
import { toast } from "@components/toast/Toast";
import RoleForm from "../forms/RoleForm";
import { useForm } from 'react-hook-form';


const AddRole = ({ isOpen, onComplete, onClose }) => {

  const [loading, setLoading] = useState(false)

  const { control, handleSubmit, setValue, reset, watch, formState: { errors, isValid }, clearErrors } = useForm({
    defaultValues: {
      name: "",
      paymentRequestLevel: "user",
      isAdmin: false,
      canUpdateSettings: false,
      customerLevel: "none",
      paymentLevel: "none",
      messageTemplateLevel: "none",
      paymentRequestTemplateLevel: "view",
      payoutLevel: "none",
      reconciliationLevel: "none",
      ledgerPaymentLevel: "none",
      useAiFeatures: false,
    }
  });

  const selectedPaymentRequestLevel = watch("paymentRequestLevel");

  const selectedAccessPermissions = {
    customerLevel: watch("customerLevel"),
    paymentLevel: watch("paymentLevel"),
    messageTemplateLevel: watch("messageTemplateLevel"),
    paymentRequestTemplateLevel: watch("paymentRequestTemplateLevel"),
    payoutLevel: watch("payoutLevel"),
    reconciliationLevel: watch("reconciliationLevel"),
    ledgerPaymentLevel: watch("ledgerPaymentLevel")
  }

  const onSubmit = async (values) => {
    setLoading(true);
    await addRole(values)
    setLoading(false);

    toast({ description: `Created "${values.name}" role` });
    onComplete();
    handleClose()
  }

  const addRole = async (values) => {
    const correctedValues = {
      ...values,
      customerLevel: values.customerLevel === "full" ? "requestfrom" : values.customerLevel,
      paymentLevel: values.paymentLevel === "full" ? "refund" : values.paymentLevel,
      messageTemplateLevel: values.messageTemplateLevel === "full" ? "update" : values.messageTemplateLevel,
      paymentRequestTemplateLevel: values.paymentRequestTemplateLevel === "full" ? "update" : values.paymentRequestTemplateLevel,
      reconciliationLevel: values.reconciliationLevel === "full" ? "action" : values.reconciliationLevel,
      ledgerPaymentLevel: values.ledgerPaymentLevel === "full" ? "action" : values.ledgerPaymentLevel,
    };

    await createRole(correctedValues)
  }

  const handleClose = () => {
    reset();
    clearErrors()
    onClose();
  }

  return <Flow isOpen={isOpen} onClose={handleClose}>
    <FlowHeader onClose={handleClose}>
      <FlowTitle>Create role</FlowTitle>
      <FlowActions>
        <Button
          color="secondary"
          type="button"
          onClick={handleClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          type="submit"
          onClick={handleSubmit(onSubmit)}
          submitting={loading}
          disabled={!isValid}
        >
          Create role
        </Button>
      </FlowActions>
    </FlowHeader>
    <FlowBody>
      <div className="flex flex-col items-center w-full h-full">
        <RoleForm
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          setValue={setValue}
          control={control}
          errors={errors}
          selectedPaymentRequestLevel={selectedPaymentRequestLevel}
          selectedAccessPermissions={selectedAccessPermissions}
        />
      </div>
    </FlowBody>
  </Flow>;
};

export default AddRole;
